import React from 'react'
// icons
import { AsteriskIcon } from 'components/FormElements/components/InputLabel'
// types
import { IField } from 'types/graphql'
import { AttachmentType, Attachment } from 'components/FormElements/DocumentOrLink/types'
// views
import {
  Text,
  Label,
  Wrapper,
  Content,
  Dropzone,
  CloseIcon,
  ActionLink,
  UploadIcon,
  LinkWrapper,
  Link as FileLink
} from './views'
// utils
import { normalizeLink } from 'utils/index'

interface DropzoneRootProps {
  [key: string]: any
}

interface Props {
  field: IField
  required: boolean
  onLine: boolean
  isDisabled?: boolean
  attachment: Attachment | null
  isDragActive: boolean
  onBrowse: () => void
  onAddLink: () => void
  onClear: (e: React.MouseEvent<HTMLElement>) => void
  getRootProps: (props?: DropzoneRootProps) => DropzoneRootProps
  getInputProps: (props?: DropzoneRootProps) => DropzoneRootProps
}

const AttachmentDropzone: React.FC<Props> = ({
  field,
  required,
  isDisabled,
  attachment,
  isDragActive,
  onBrowse,
  onAddLink,
  onClear,
  getRootProps,
  getInputProps
}) => {
  return (
    <Wrapper>
      <Label>
        {required && <AsteriskIcon />} {field.label}
      </Label>

      {attachment ? (
        <LinkWrapper>
          {attachment._pending ? (
            <span>{attachment.name}</span>
          ) : (
            <FileLink
              target='_blank'
              isDisabled={isDisabled}
              href={attachment.type === AttachmentType.Image ? attachment.url : normalizeLink(attachment.url)}>
              {attachment.name || attachment.title || attachment.url}
            </FileLink>
          )}
          {!isDisabled && <CloseIcon onClick={onClear} />}
        </LinkWrapper>
      ) : (
        <Dropzone {...getRootProps()} $isDragActive={isDragActive} $disabled={isDisabled}>
          <input {...getInputProps()} />
          <Content>
            <UploadIcon />
            <Text>
              Drop files to attach, <ActionLink onClick={onBrowse}>browse</ActionLink> or{' '}
              <ActionLink onClick={onAddLink}>add link</ActionLink>
            </Text>
          </Content>
        </Dropzone>
      )}
    </Wrapper>
  )
}

export default AttachmentDropzone
